var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUberBackgroundGraphic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1499px",
    height: "1608px",
    viewBox: "0 0 1499 1608",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Welcome",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(589.000000, 0.000000)",
    stroke: "#11949C",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    transform: "translate(453.000000, 453.000000) scale(1, -1) translate(-453.000000, -453.000000) ",
    cx: 453,
    cy: 453,
    r: 453
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 453,
    cy: 1151,
    r: 453
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 11.000000)",
    stroke: "#11949C",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 453,
    cy: 453,
    r: 453
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    transform: "translate(454.000000, 1130.000000) scale(1, -1) translate(-454.000000, -1130.000000) ",
    cx: 454,
    cy: 1130,
    r: 453
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(393.000000, 455.000000)",
    stroke: "#11949C",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    transform: "translate(177.500000, 177.500000) scale(-1, 1) translate(-177.500000, -177.500000) ",
    cx: 177.5,
    cy: 177.5,
    r: 177.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 177.5,
    cy: 517.5,
    r: 177.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(748.000000, 455.000000)",
    stroke: "#11949C",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 177.5,
    cy: 177.5,
    r: 177.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    transform: "translate(177.500000, 517.500000) scale(-1, 1) translate(-177.500000, -517.500000) ",
    cx: 177.5,
    cy: 517.5,
    r: 177.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(671.000000, 725.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    fill: "#0A2F3C",
    x: 54,
    y: 49,
    width: 55,
    height: 58
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6579693,73.2439024 L2.22044605e-16,73.2439024 C1.95998729,32.4625176 35.6642478,0 76.9549696,0 C119.505765,0 154,34.4740743 154,77 C154,119.525926 119.505765,154 76.9549696,154 C35.8757335,154 2.30544392,121.869168 0.0326135319,81.3821138 L55.6579693,81.3821138 L55.6579693,94.5365854 C55.6579693,97.2980091 57.8965456,99.5365854 60.6579693,99.5365854 L94.5047346,99.5365854 C97.2661583,99.5365854 99.5047346,97.2980091 99.5047346,94.5365854 L99.5047346,60.7154472 C99.5047346,57.9540234 97.2661583,55.7154472 94.5047346,55.7154472 L60.6579693,55.7154472 C57.8965456,55.7154472 55.6579693,57.9540234 55.6579693,60.7154472 L55.6579693,73.2439024 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUberBackgroundGraphic);
export default __webpack_public_path__ + "static/media/uberBackgroundGraphic.2c5c24c4e2c3e211b886a8397d2db6ad.svg";
export { ForwardRef as ReactComponent };